<template>
  <div class="attribute">
    <div class="container">
      <div class="attribute__row" v-if="dataMissing">
        <div class="attribute__no-data">No records found</div>
      </div>
      <div class="attribute__row" v-else-if="!isDataFetched">
        <div class="attribute__loader">
          <base-loader/>
        </div>
      </div>
      <div class="content" v-else>
        <div class="attribute__row attribute__row_top">
          <base-content-block class="attribute__row-item"
                              title="Attribute Comparison"
                              slotLess>
            <div v-if="isComparison"
                 class="no-data-block">
              No records found
            </div>
            <div class="attribute__chart-wrapper" v-else>
              <comparison :data="comparison"/>
            </div>
          </base-content-block>
          <base-content-block class="attribute__row-item"
                              title="Attribute Overlap"
                              slotLess>
            <overlap :is-active="isOverlapActive"
                     @show-overlap="openPopup"/>
          </base-content-block>
        </div>

        <advanced-options
          class="attribute__advanced"
          :copyPage="true"
          :options="advancedOptions"
          :predefinedOptions="_advancedFilters"
          @copy="copyFilters"
          @apply-advanced="applyAdvancedOptions"/>

        <div class="attribute__row attribute__export-container">
          <base-content-block class="attribute__table-block"
                              :headerStyle="{ 'border-bottom': 'none' }"
                              title="Attributes"
                              slotLess>
            <div class="attribute__table-wrapper">
              <div v-if="!isAttributes"
                   class="no-data-block">
                No records found
              </div>
              <div class="common-table" v-if="isAttributes">

                <div class="common-table__row attribute__row_border attribute__header">
                  <div class="common-table__header-cell common-table__cell_bold common-table__name">Audience Key Totals  &raquo;</div>
                  <div class="common-table__header-cell common-table__cell_bold" v-for="cell in columnsConfig.slice(1, columnsConfig.length)"
                       :key="cell.property">{{getValue(allAttributes, cell)}}</div>
                </div>
                <div class="common-table__row common-table__header">
                  <div class="common-table__header-cell common-table__cell"  v-for="cell in columnsConfig"
                       :class="{'common-table__name' : cell.propName === 'label'}"
                       :key="cell.label" @click.stop="onHeaderCellClicked(cell)">{{cell.label}}
                    <base-table-sortable-column
                      :prop-name="cell.propName"
                      :sort-config="sortConfig"/>
                  </div>
                </div>
                <div class="common-table__row common-table__row-content" v-for="item in sortedData" :key="item.label">

                  <div class="common-table__cell common-table__name">
                    <base-three-position-check-box class="common-table__checkbox"
                                                         v-model="item.checked"
                                                         @change="onCheckboxChanged(item)"
                                                         :disabled="isCheckboxesDisabled"/>
                    <span class="common-table__label">
                      <a :href="attributeDownloadLink(item)" target="_blank">{{item.label}}</a>
                    </span>
                  </div>
                  <div class="common-table__cell" v-for="cell in columnsConfig.slice(1, columnsConfig.length)"
                       :key="cell.property">{{getValue(item, cell)}}</div>
                </div>
              </div>
              <div class="attribute__footer" v-if="isAttributes">
                <span class="attribute__result">{{customResultLabel()}}</span>
                <div class="attribute__controls">
                  <button class="attribute__button attribute__button_clear"
                          @click.prevent="resetCustom()"
                          :class="{'attribute__button_disabled': isResetButtonDisabled}"
                  >
                    Reset
                  </button>
                  <button class="attribute__button attribute__button_apply"
                          @click.prevent="applyCustom()"
                          :class="{'attribute__button_disabled': isApplyCustomButtonDisabled}">
                    Add to custom list
                  </button>
                </div>
              </div>
            </div>
          </base-content-block>
          <base-material-design-icon class="attribute__export-button"
                                  v-if="isAttributes"
                                  icon="download"
                                  @click="exportCsvCustom('attribute')"/>
        </div>

        <div class="attribute__row attribute__export-container">
          <base-content-block class="attribute__table-block"
                              :headerStyle="{ 'border-bottom': 'none' }"
                              title="Custom List"
                              slotLess>
            <div v-if="!isAttributes"
                 class="no-data-block">
              No records found
            </div>
            <div class="common-table" v-else>
              <div class="common-table__row attribute__header" :class="{'attribute__row_border': isCustom || numberDownloadingCustoms}">
                <div class="common-table__header-cell common-table__cell_bold common-table__name-custom">Audience Key Totals  &raquo;</div>
                  <div class="common-table__header-cell common-table__cell_bold" v-for="cell in columnsConfig.slice(1, columnsConfig.length)"
                       :key="cell.property">{{getValue(allAttributes, cell)}}</div>
              </div>
              <div class="common-table__row common-table__header">
                <div class="common-table__header-cell common-table__cell"  v-for="cell in columnsConfig"
                       :class="{'common-table__name' : cell.propName === 'label'}"
                       :key="cell.label">{{cell.label}}</div>
              </div>
              <div class="common-table__row common-table__row-content"
                   v-for="item in custom"
                   :key="item.label">
                <div class="common-table__cell common-table__name-custom">
                  <span class="common-table__label">
                      <a :href="attributeDownloadLink(item)" target="_blank">{{item.label}}</a>
                    </span>
                  <base-overlap-icon class="attribute__row-icon" @overlap-click="onOverlapIconClick(item)" v-if="isMultiAttributes(item)"/></div>
                <div class="common-table__cell" v-for="cell in columnsConfig.slice(1, columnsConfig.length)"
                       :key="cell.property">{{getValue(item, cell)}}
                  <div v-if="cell.propName === 'kw_percent'"
                       class="common-table__delete-button"
                       @click.stop="onDeleteCustom(item)"/></div>
              </div>
              <div class="common-table__row attribute__horizontal-loader-wrap" v-if="numberDownloadingCustoms">
                <base-horizontal-loader class="attribute__horizontal-loader"/>
              </div>
            </div>
          </base-content-block>
          <base-material-design-icon class="attribute__export-button"
                                  v-if="isCustomExportAllowed"
                                  icon="download"
                                  @click="exportCsvCustom('custom')"/>
        </div>
      </div>
    </div>

    <modal name="venn-diagram"
           v-bind="vennDiagramModalProps">
      <VennDiagramPopup
        title="Attribute Overlap"
        :selectedAdvancedOptions="selectedAdvancedOptions"
        :selected-ids="selectedIds"
        @close="hidePopup">
      </VennDiagramPopup>
    </modal>

    <div class="attribute__update-loader" v-if="isDataUpdating">
      <base-loader class="attribute__update-loader-ring"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Overlap from './Overlap'
import Comparison from './Comparison'
import baseModalProps from '@/common/BaseModalProps'
import VennDiagramPopup from '../common/VennDiagramPopup'
import csvExport from '@/services/CSVExport'
import filters from '@/common/Filters'
import _ from 'lodash'
import helper from '@/services/Helper'
import BaseSortMixins from '@/common/BaseSortMixins'
import moment from 'moment'
import { convertAdvancedOptionsToURLParams } from '@/store/modules/rank-zone/Helper'
import {
  addOptionsToConfig,
  ADVANCED_OPTION_TYPE,
  convertAdvancedOptionsToFilters,
  attributesFieldsConfig
} from '@/features/reports/common/advanced-options/config'
import AdvancedOptions from '@/features/reports/common/advanced-options/AdvancedOptions'
import { advancedFiltersMixins } from '@/features/reports/common/AdvancedFiltersMixins'
import { baseComponent } from '@/features/reports/common/Mixins'

const MAX_CHECKBOX_CHECKED = 4
const MIN_CHECKBOX_CHECKED = 1
const MIN_CHECKBOX_CHECKED_FOR_OVERLAP = 2
/**
 * Attribute Report component
 */
export default {
  name: 'AttributeReport',
  components: {
    Overlap,
    Comparison,
    VennDiagramPopup,
    AdvancedOptions
  },
  mixins: [BaseSortMixins, advancedFiltersMixins, baseComponent],
  created () {
    if (this.selectedClient) {
      this.loadPageData()
    }
  },
  data () {
    return {
      // list of custom items currently selected from attribute table
      currentCustomItems: [],
      isDataFetched: false,
      // values for attribute table header
      allAttributes: {},
      // data for Comparison component
      comparison: [],
      // summary data for Comparison component
      allComparison: {},
      // selected attributes in format { exclude: [], include: [] }
      selectedIds: {},
      // sorted attribute data
      sortedData: [],
      // number custom item pending requests
      numberDownloadingCustoms: 0,
      // table config. Used for both - attribute table and custom table
      columnsConfig: [
        {
          label: 'All Attributes',
          propName: 'label'
        },
        {
          label: 'MSV',
          propName: 'msv'

        },
        {
          label: '# of KW',
          propName: 'keywords'
        },
        {
          label: 'MSV%',
          propName: 'msv_percent'
        },
        {
          label: 'KW%',
          propName: 'kw_percent'
        }
      ],
      selectedAdvancedOptions: []
    }
  },
  computed: {
    ...mapState('attributeReport', {
      attributes (state) {
        this.allAttributes = {
          msv: state.all.msv,
          msv_percent: 100,
          kw_percent: 100,
          keywords: state.all.keywords
        }
        this.allComparison = {
          name: 'All Keyword MSV',
          value: this.allAttributes.msv,
          percent: 100
        }
        this.comparison = [ this.allComparison ]

        const attributes = []
        state.attributes.forEach(item => {
          this.$set(item, 'checked', false)
          attributes.push(item)
        })
        return attributes
      },
      custom (state) {
        return state.custom
      }
    }),
    ...mapState('rankZoneCommon', {
      /**
       * modify advanced options config {@link #urlFieldsConfig}
       * by received form backend client specific data
       * */
      advancedOptions: function (state) {
        let config = _.cloneDeep(attributesFieldsConfig)
        addOptionsToConfig(config, state.sections, ADVANCED_OPTION_TYPE.SECTION)
        addOptionsToConfig(config, state.urlStatuses, ADVANCED_OPTION_TYPE.URL_STATUS)
        addOptionsToConfig(config, state.pageTypes, ADVANCED_OPTION_TYPE.PAGE_TYPE)
        addOptionsToConfig(config, state.scores, ADVANCED_OPTION_TYPE.SCORE)
        addOptionsToConfig(config, state.serpFeature, ADVANCED_OPTION_TYPE.SERP_FEATURE)
        addOptionsToConfig(config, state.isOptimized, ADVANCED_OPTION_TYPE.IS_OPTIMIZED)
        addOptionsToConfig(config, state.contentBriefStatuses, ADVANCED_OPTION_TYPE.CONTENT_BRIEF_STATUS)
        addOptionsToConfig(config, state.mappedUrls, ADVANCED_OPTION_TYPE.URL)
        return this.isClientDifficultyScoreEnabled ? config : config.filter(i => i.type !== ADVANCED_OPTION_TYPE.DIFF_SCORE)
      }
    }),
    dataMissing () {
      return this.isDataFetched && !this.isAttributes && !this.selectedAdvancedOptions.length
    },
    vennDiagramModalProps: function () {
      const vennDiagramModalProps = {
        width: 1184
      }
      return { ...baseModalProps, ...vennDiagramModalProps }
    },
    isAttributes () {
      return this.attributes && this.attributes.length
    },
    isCheckboxesDisabled () {
      return this.numberCheckedItems >= MAX_CHECKBOX_CHECKED
    },
    isOverlapActive () {
      return this.numberCheckedItems >= MIN_CHECKBOX_CHECKED_FOR_OVERLAP
    },
    isCustomExportAllowed () {
      return this.custom.length > 0
    },
    isComparison () {
      return !this.comparison || !this.comparison.length
    },
    isCustom () {
      return this.custom && this.custom.length
    },
    isApplyCustomButtonDisabled () {
      const checkedCount = this.attributes.reduce((count, item) => {
        item.checked && count++
        return count
      }, 0)
      return checkedCount < MIN_CHECKBOX_CHECKED
    },
    isResetButtonDisabled () {
      return !this.attributes.some(item => Boolean(item.checked))
    },
    numberCheckedItems () {
      return this.attributes.reduce((checked, item) => {
        if (item.checked) {
          checked++
        }
        return checked
      }, 0)
    }
  },
  methods: {
    ...mapActions('attributeReport', [
      'getAttributeData',
      'getCustomConstructorData',
      'resetData',
      'resetOverlapChartData',
      'setNewCustomData',
      'resetCustomReport',
      'deleteCustomItem' ]),

    async loadPageData () {
      if (this.isDataFetched) {
        this.isDataUpdating = true
      }
      const advancedFilters = convertAdvancedOptionsToFilters(this.selectedAdvancedOptions)
      await this.getAttributeData({
        clientId: this.clientId,
        filters: { advancedFilters }
      })
      // copy of current custom list
      const currentCustomList = _.cloneDeep(this.custom)
      // update according new advanced filters
      const updatedCustomList = await Promise.all(currentCustomList.map(async (item) => {
        const data = await this.getCustomConstructorData({
          clientId: this.clientId,
          filters: {
            selectedIds: {
              include: item.include,
              exclude: item.exclude
            },
            advancedFilters
          },
          disableSaveToState: true
        })

        return data.result
      }))
      this.setNewCustomData(updatedCustomList)
      this.isDataUpdating = false
      this.isDataFetched = true
    },
    /**
     * {@link AdvancedOptions} callback
     * @param options - applied advanced options
     */
    async applyAdvancedOptions (options) {
      this.selectedAdvancedOptions = _.cloneDeep(options)
      await this.loadPageData()
    },
    onDeleteCustom (item) {
      this.deleteCustomItem({ item })
    },
    getValue (item, cell) {
      if (!cell || !item) {
        return ''
      }
      const value = item[cell.propName] || 0
      switch (cell.propName) {
        case 'msv_percent':
        case 'kw_percent':
          return `${value}%`
          // don't need it any more because round on the back-end
          // return `${filters.roundNumber(value, 2)}%`
        case 'msv':
          return filters.commaDividedNumber(filters.roundNumber(value))
        case 'keywords':
          return filters.commaDividedNumber(value)
      }
    },
    attributeDownloadLink (attribute) {
      const advancedFilters = convertAdvancedOptionsToFilters(this.selectedAdvancedOptions)
      let params = null
      if (attribute._id) {
        params = convertAdvancedOptionsToURLParams({
          exclude: [''],
          include: attribute._id,
          advancedFilters
        })
      } else if (attribute.exclude && attribute.include) {
        params = convertAdvancedOptionsToURLParams({
          exclude: attribute.exclude,
          include: attribute.include,
          advancedFilters
        })
      } else {
        return null
      }
      if (process.env.VUE_APP_IS_V2_API === 'true') {
        return `${window.location.origin}/rest/v2/reports/attribute-report/export-csv/${this.clientId}?${params}`
      } else {
        return `${window.location.origin}/rest/reports/attribute-report/export-csv/${this.clientId}?${params}`
      }
    },
    exportCsvCustom (table) {
      let list = []
      let reportName = ''
      if (table === 'attribute') {
        list = this.sortedData
        reportName = 'AttributeReport'
      } else {
        list = this.custom
        reportName = 'CustomAttributeReport'
      }
      const header = [ 'Attribute', 'MSV', 'Keywords', 'MSV%', 'KW%' ]
      const all = [ 'All attributes',
        this.allAttributes.msv,
        this.allAttributes.keywords,
        this.allAttributes.msv_percent,
        this.allAttributes.kw_percent ]
      const data = [ header, all ]
      list.forEach(item => {
        data.push([
          item.label,
          item.msv,
          item.keywords,
          item.msv_percent,
          item.kw_percent ])
      })
      csvExport(`${this.selectedClient.name.replace(/ /g, '_')}_${reportName}_${moment().format('YYYY-MM-DD')}`, data)
    },
    /**
     * open {@link VennDiagramPopup}
     * */
    openPopup () {
      this.calculateSelectedIds()
      this.$modal.show('venn-diagram')
    },
    hidePopup () {
      this.$modal.hide('venn-diagram')
      this.selectedIds = {}
      this.resetOverlapChartData()
      this.resetCustomReport()
    },
    onCheckboxChanged (item) {
      if (item.checked) {
        const saved = this.currentCustomItems.find(i => i._id === item._id)
        if (!saved) {
          this.currentCustomItems.push(item)
        }
      } else {
        this.currentCustomItems.splice(this.currentCustomItems.indexOf(item), 1)
      }
    },
    reset () {
      this.resetData()
      this.allAttributes = []
    },
    resetCustom () {
      this.currentCustomItems = []
      this.attributes.forEach(item => {
        this.$set(item, 'checked', false)
      })
    },
    async applyCustom () {
      this.numberDownloadingCustoms++
      this.calculateSelectedIds()
      this.resetCustom()
      const advancedFilters = convertAdvancedOptionsToFilters(this.selectedAdvancedOptions)
      await this.getCustomConstructorData({ clientId: this.clientId, filters: { selectedIds: this.selectedIds, advancedFilters } })
    },
    customResultLabel () {
      const label = this.currentCustomItems.reduce((title, item) => {
        const operator = item.checked === 'plus' ? ' + ' : ' - '
        title += operator + item.label
        return title
      }, '').trim()
      if (label.startsWith('+')) {
        return label.slice(1)
      }
      return label
    },
    /**
     * callback for overlap icon on custom lis
     * @param item
     */
    onOverlapIconClick (item) {
      const filterFunc = item => !_.isEmpty(item)
      this.selectedIds = { exclude: item.exclude.filter(filterFunc), include: item.include.filter(filterFunc) }
      this.$modal.show('venn-diagram')
    },
    calculateSelectedIds () {
      this.selectedIds = this.attributes.reduce((acc, item) => {
        if (item.checked === 'plus') {
          acc.include.push(item._id)
        }
        if (item.checked === 'minus') {
          acc.exclude.push(item._id)
        }
        return acc
      }, { exclude: [], include: [] })
    },
    /**
     * show overlap icon on custom list only if there is several attributes selected
     */
    isMultiAttributes (customItem) {
      const exclude = customItem.exclude.filter(item => item)
      const include = customItem.include.filter(item => item)
      return exclude.length + include.length > 1
    },
    sortData () {
      if (!this.sortConfig.length) {
        this.sortedData = _.cloneDeep(this.attributes)
        return
      }
      const { propertyName, sortDirection, valuePreFormatter } = this.sortConfig[0]
      this.sortedData = helper.sortByParam(this.attributes, propertyName, sortDirection, valuePreFormatter)
    }
  },
  watch: {
    selectedClient (client) {
      if (!client) {
        return
      }
      this.reset()
      this.isDataFetched = false
      this.loadPageData(this.clientId)
    },
    /**
     * by changing attribute values in table Attribute Comparison data should be changed
     */
    numberCheckedItems () {
      if (!this.numberCheckedItems) {
        this.comparison = [ this.allComparison ]
        return
      }
      const selected = this.attributes.reduce((acc, item) => {
        if (item.checked) {
          acc.value += item.msv
          acc.percent += item.msv_percent
        }
        return acc
      }, { name: 'Selected Attributes', value: 0, percent: 0 })
      const all = {
        name: 'All Keyword MSV',
        value: this.allAttributes.msv - selected.value,
        percent: 100 - selected.percent
      }
      this.comparison = [ all, selected ]
    },
    /**
     * after change custom in store change number downloading items accordingly
     */
    custom () {
      this.numberDownloadingCustoms > 0 && this.numberDownloadingCustoms--
    },
    sortConfig: {
      handler () {
        this.sortData()
      },
      deep: true
    },
    attributes () {
      this.sortData()
    }
  },
  filters: {
    roundNumber: filters.roundNumber,
    commaDividedNumber: filters.commaDividedNumber
  }
}
</script>

<style scoped lang="scss">
  .attribute {
    &__loader {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      height: calc(100vh - 530px);
    }
    &__advanced {
      margin: 14px 0;
    }
    &__update-loader {
      position: fixed;
      display: flex;
      justify-content: center;
      background-color: white;
      top: 0;
      opacity: 0.5;
      z-index: 10000;
      bottom: 0;
      right: 0;
      left: 0;
    }
    &__update-loader-ring {
      margin-top: 200px;
    }
    &__horizontal-loader {
      position: absolute;
      top: -2px;
      left: 50%;
      transform: translateX(-50%);
    }
    &__horizontal-loader-wrap {
      height: 60px;
      box-sizing: border-box;
      overflow: hidden;
      padding: 0;
      position: relative;
    }
    &__no-data {
      display: flex;
      height: 300px;
      background-color: #fff;
      border-radius: $rfx-default-border-radius;
      align-items: center;
      justify-content: center;
      font-size: 27px;
      font-weight: 600;
      color: $rfx-medium-grey;
      flex: 1 1;
    }
    &__breadcrumbs {
      position: relative;
      margin: -5px 0 22px;
    }

    &__download {
      position: absolute;
      top: 0;
      right: 5px;
    }

    &__table-block {
      flex: 1 1;
      display: flex;
      flex-direction: column;
    }

    &__table-wrapper {
      display: flex;
      flex-direction: column;
      flex: 1 1 100%;
    }

    &__row {
      display: flex;
      align-items: stretch;
      justify-content: space-between;
      margin-bottom: 14px;

      &_top {
        min-height: 305px;
      }

      &_border {
        border-bottom: 2px solid $rfx-silver;
      }

      &-item {
        flex: 1 1 100%;
        overflow: hidden;

        &:first-child {
          margin-right: 14px;
        }
      }
    }

    &__row-icon {
      margin-right: 78px;
    }

    &__chart-wrapper {
      width: 100%;
      padding: 15px 0 15px 40px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
    }
    &__header{
      background-color: $rfx-bright-grey;
    }

    &__export-container {
      position: relative;
    }

    &__export-button {
      position: absolute;
      top: 22px;
      right: 10px;
    }
    &__controls {
      display: flex;
      flex: 1 1;
      overflow: hidden;
      justify-content: flex-end;
    }

    &__button {
      height: 40px;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 900;
      text-transform: uppercase;
      margin-left: 30px;
      border: none;
      outline: none;
      cursor: pointer;

      &_disabled {
        color: $rfx-neutral-grey !important;
        pointer-events: none;
        background-color: transparent;
        cursor: default;
      }

      &_apply {
        background-color: $rfx-medium-march;
        color: #fff;
        width: 195px;
      }

      &_disabled {
        color: $rfx-neutral-grey !important;
        pointer-events: none;
        background-color: transparent;
        cursor: default;
      }

      &_clear {
        background-color: transparent;
        color: $rfx-dark-march;
        width: 100px;
      }
    }

    &__result {
      font-size: 13px;
      color: $rfx-light-march;
      flex: 1 1 40%;
    }

    &__footer {
      display: flex;
      justify-content: space-around;
      padding: 20px 30px;
      align-items: center;
    }
  }

  .common-table {
    flex: 1 1;

    &__header {
      background-color: rgba(1, 22, 39, 0.1);
    }

    &__checkbox {
      flex: 0 1 60px;
      justify-content: center;
      box-sizing: border-box;
    }

    &__row-content {
      border-bottom: 2px solid $rfx-light-steel;
      &:first-child {
        font-weight: 500;
      }
      &:last-child{
        border-bottom: 1px solid $rfx-light-steel;
      }
    }

    &__cell {
      color: $rfx-light-march;
      font-size: 14px;
      border: none;
      position: relative;
    }

    &__name-custom,
    &__name {
      flex: 1 1 40%;
      font-weight: 500;
      color: $rfx-dark-march;
      @include ellipsis;
    }

    &__name {
      display: flex;
      align-items: center
    }

    &__label {
      margin-left: 30px;

      a {
        display: inline-block;
        color: $rfx-dark-march;
        text-decoration: none;

        &:hover {
          color: $rfx-bright-blue !important;
          text-decoration: underline;
        }

        &:visited {
          color: $rfx-dark-march;
        }
      }
    }

    &__name-custom {
      display: flex;
      justify-content: space-between;
    }

    &__header-cell {
      color: $rfx-dark-march;
      font-weight: bold;
      font-size: 14px;
      border: none;
      display: flex;
      align-items: center;
    }

    &__cell {
      position: relative;
      &_bold {
        font-weight: 500;
      }
    }

    &__delete-cell {
      flex: 0 1;
      position: relative;
    }

    &__delete-button {
      position: absolute;
      top: 22px;
      right: 30px;
      width: 16px;
      height: 16px;
      background-color: #000;
      border-radius: 50%;
      cursor: pointer;

      &:hover {
        opacity: 1;
      }

      &:before, &:after {
        position: absolute;
        left: 7px;
        top: 3px;
        content: '';
        height: 10px;
        width: 2px;
        background-color: #fff;
      }

      &:before {
        transform: rotate(45deg);
      }

      &:after {
        transform: rotate(-45deg);
      }
    }
  }

</style>
